module.exports = __webpack_public_path__ + "static/media/headquarter-avatar-256.11306326.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/footer/headquarter-avatar-256.jpg
// module id = 513
// module chunks = 0